import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { message, MagicInput } from 'hljd'
import style from './style.module.less'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: '',
      text: ''
    }
  }

  componentDidMount() {
    const { title, text } = this.props.active || {}
    this.setState({ title, text })
    document.addEventListener('click', this.saveTitle)
  }

  componentDidUpdate({ active }) {
    const { title, text } = this.props.active || {}
    if (active && (active.title != title || active.text != text)) {
      this.setState({ title, text })
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.saveTitle)
  }

  handleClick = e => {
    e.nativeEvent.stopImmediatePropagation()
  }

  changeCaseTitle = title => {
    this.setState({ title })
    this.props.store.saveCaseValue('title', title)
  }

  changeCaseText = text => {
    this.setState({ text })
    this.props.store.saveCaseValue('text', text)
  }

  saveTitle = async () => {
    const { title = '', text = '' } = this.state
    if (!title && !text) {
      message.warning('标题或者描述必填一项')
      return
    }
    const data = await this.props.store.checkWord(title + text, 2)
    const { code, keywords } = data
    if (code == 1) {
      message.warning(`存在敏感词 ${keywords.join(',')}`)
      return
    }
    const { saveCaseTitle } = this.props.store
    saveCaseTitle(this.state)
  }

  render() {
    const { title, text } = this.state
    return (
      <div className={style.caseEditor} onClick={this.handleClick}>
        <div className={style.editorBar}>
          <p className={style.editorTitle}>文字模块</p>
        </div>
        <div className={style.editorCenter}>
          <div className={style.titleBar}>
            <MagicInput
              showCount
              countPosition="inner"
              maxLength={10}
              value={title}
              placeholder="标题"
              onChange={e => this.changeCaseTitle(e.target.value)}
            />
          </div>
          <div className={style.textBar}>
            <MagicInput.TextArea
              showCount
              countPosition="inner"
              maxLength={200}
              value={text}
              placeholder="详情介绍"
              onChange={e => this.changeCaseText(e.target.value)}
            />
          </div>
        </div>
      </div>
    )
  }
}
